/**
 * SA-795 (D6): the Inbox record sidebar's width limits. The handle and the
 * sidebar read them, and the settings store keeps only the number a person
 * chose (`ui.inboxRecordSidebarWidth`, null = the default). The rule itself is
 * every panel's (`components/ui/panelWidth`, SA-813).
 */
import { storedWidth } from '@/components/ui/panelWidth'

export const SIDEBAR_WIDTH = { default: 320, min: 256, max: 560 } as const

/** The width to draw for a stored value (`panelWidth.storedWidth`). */
export function sidebarWidth(stored: unknown): number {
  return storedWidth(stored, SIDEBAR_WIDTH)
}
